import { PAGE_TYPE, DEPARTMENT, FORM_TYPE, FLOW_NAME, ELEMENT_TYPE, COMM_TYPE, EVENT_ACTION } from './parameter'

const ASC_EVENT_ACTION = {
  pageView: 'asc_pageview',
  retailProcess: 'asc_retail_process',
  ctaInteraction: 'asc_cta_interaction',
  formEngagement: 'asc_form_engagement',
  formSubmission: 'asc_form_submission',
  formSubmissionSales: 'asc_form_submission_sales',
  formSubmissionSalesAppt: 'asc_form_submission_sales_appt',
  clickTocall: 'asc_click_to_call'
}

const ASC_EVENT_DEFAULT = {
  event_owner: 'kbb',
  product_name: 'ico',
  page_type: PAGE_TYPE.trade
}

const ASC_PAGE_VIEW = {
  event_name: ASC_EVENT_ACTION.pageView,
  ...ASC_EVENT_DEFAULT
}

const ASC_RETAIL_PROCESS = {
  ...ASC_EVENT_DEFAULT,
  event_name: ASC_EVENT_ACTION.retailProcess,
  flow_name: FLOW_NAME.trade,
  element_title: '',
  flow_outcome: ''
}

const ASC_CTA_INTERACTION = {
  ...ASC_EVENT_DEFAULT,
  event_name: ASC_EVENT_ACTION.ctaInteraction,
  element_type: ELEMENT_TYPE.trade_tool,
  event_action: EVENT_ACTION.click
}

const ASC_FORM_ENGAGEMENT = {
  ...ASC_EVENT_DEFAULT,
  ...COMM_TYPE.form,
  event_name: ASC_EVENT_ACTION.formEngagement, // G3
  department: DEPARTMENT.trade,
  form_type: FORM_TYPE.trade,
  form_name: 'ico_contact'
}

const ASC_FORM_SUBMISSION = {
  ...ASC_EVENT_DEFAULT,
  ...COMM_TYPE.form,
  event_name: ASC_EVENT_ACTION.formSubmission,
  department: DEPARTMENT.trade,
  form_type: FORM_TYPE.trade,
  element_text: '',
  comm_outcome: '',
  form_name: ''
}

const ASC_FORM_SUBMISSION_SALES = {
  ...ASC_FORM_SUBMISSION,
  event_name: ASC_EVENT_ACTION.formSubmissionSales
}

const ASC_FORM_SUBMISSION_SALES_APPT = {
  ...ASC_FORM_SUBMISSION,
  event_name: ASC_EVENT_ACTION.formSubmissionSalesAppt
}

const ASC_CLICK_TO_CALL = {
  ...ASC_EVENT_DEFAULT,
  event_name: ASC_EVENT_ACTION.clickTocall,
  department: DEPARTMENT.trade
}

export default { ASC_PAGE_VIEW, ASC_RETAIL_PROCESS, ASC_CTA_INTERACTION, ASC_FORM_ENGAGEMENT, ASC_FORM_SUBMISSION, ASC_FORM_SUBMISSION_SALES, ASC_FORM_SUBMISSION_SALES_APPT, ASC_CLICK_TO_CALL }
